<template>
  <div>
    <header class="header">
      <div class="bb-container-max">
        <div class="header__container">
          <div class="header__logo">
            <router-link :to="logoLink" aria-current="page">
              <img
                src="../../assets/img/logos/logo-hellobb-dark.svg"
                alt="Logo HelloBB"
              />
            </router-link>
          </div>
          <div :class="'header__nav__fr-FR'">
            <HeaderNav :headerLang="headerLang" :headerType="headerType" />
          </div>
          <div class="header__right">
            <HeaderUser :headerLang="headerLang" />
            <div class="header__hucha" v-if="showLittlePig && !hidePiggyBank">
              <router-link to="/contributions">
                <img
                  class="header-nav-icon"
                  src="../../assets/img/ico/ico-nav-hucha.svg"
                  alt=""
                />
              </router-link>
            </div>
            <!-- display only in responsive -->
            <div class="header__hucha-responsive" v-else-if="showLittlePigNoContributions && !hidePiggyBank">
              <router-link to="/mi-hucha/crear">
                <img
                  class="header-nav-icon"
                  src="../../assets/img/ico/ico-nav-hucha.svg"
                  alt=""
                />
              </router-link>
            </div>
            <div class="header__cart" v-if="featureEcommerceAvailable && headerLang != 'fr-FR' && headerLang != 'it-IT' && headerLang != 'en-GB' && headerLang != 'de-DE' && headerLang != 'nl-NL' && headerLang != 'pt-BR'">
              <Cart />
            </div>
            <div class="header__burger">
              <div class="nav-m-right">
                <div @click="openMenu()" class="nav-m-right__item">
                  <img
                    class="header-nav-icon"
                    src="../../assets/img/ico/ico-burger.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="300"
      class="m-nav"
    >
      <div v-if="open" class="m-nav__overlay">
        <transition name="slide-fade">
          <div v-if="open" class="m-nav__content">
            <div class="m-nav__header">
              <div @click="openMenu()" :class="{ 'w-open': open }" class="">
                <img
                  class="ico-close"
                  src="../../assets/img/ico/ico-burger-close.svg"
                  alt=""
                />
              </div>
            </div>

            <div class="m-nav__nav">
              <LazyHydrate when-visible>
                <HeaderNav :headerLang="headerLang" :headerType="headerType" />
              </LazyHydrate>
            </div>
            <div class="m-nav__login offnav">
              <LazyHydrate when-visible>
                <HeaderUser :headerLang="headerLang" />
              </LazyHydrate>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderNav from "./HeaderNav.vue";
import HeaderUser from "./HeaderUser.vue";
import Cart from "./Cart.vue";
import LazyHydrate from "vue-lazy-hydration";
import Features from "../../Mixins/Features";

export default {
  name: "HeaderPartial",
  components: {
    HeaderNav,
    HeaderUser,
    Cart,
    LazyHydrate,
  },
  mixins: [
    Features,
  ],
  props: {
    headerLang: {
      type: String,
      default: "es-ES",
    },
    headerType: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
      contributionsFlag: "contributionsFlag",
      isAuthenticated: "isAuthenticated",
      hidePiggyBank: "hidePiggyBank",
    }),
    showLittlePig() {
      // return (
      //   this.contributionsFlag &&
      //   this.isAuthenticated &&
      //   this.user?.stripeAccountId != null &&
      //   this.user?.stripeAccountId != ""
      // );
      return (
        this.contributionsFlag &&
        this.isAuthenticated &&
        this.user?.contributionMethods?.length > 0
      );
    },
    showLittlePigNoContributions() {
      // return (
      //   this.contributionsFlag &&
      //   this.isAuthenticated &&
      //   (this.user?.stripeAccountId == null ||
      //   this.user?.stripeAccountId == "")
      // );
      return (
        this.contributionsFlag &&
        this.isAuthenticated &&
        this.user?.contributionMethods?.length == 0
      );
    },
    logoLink() {
      if (this.user) {
        //return { path: this.$t("routes.mi-lista", this.headerLang) };
        return { name: "owner-list" };
      }

      return { name: this.$t("routes.name.home", this.headerLang) };
    },
  },
  data() {
    return { open: false };
  },
  watch: {
    $route() {
      this.open = false;
    },
  },
  methods: {
    toggleSearch() {
      this.$store.commit("SET_SEARCHSTATE", !this.$store.state.searchState);
    },
    openMenu: function () {
      this.open = !this.open;
    },
    getImgUrl() {
      return process.env.URL_IMG_USER + this.user.photo;
    },
  },
};
</script>
